import { useRouter } from 'expo-router';
import Head from 'expo-router/head';
import { StyleSheet, View } from 'react-native';

import { Screen } from '~/components/Screen';
import { TopNav } from '~/components/TopNav';
import { EmptyState } from '~/components/ui';
import { space } from '~/ui/tokens';

// Any URL that matches no route. Without this, expo-router shows its own
// developer screen ("Unmatched Route" with a sitemap link) in production too.
export default function NotFoundScreen() {
    const router = useRouter();
    return (
        <Screen>
            <Head>
                <title>Page not found — SuiteScanner</title>
                <meta name="robots" content="noindex" />
            </Head>
            <TopNav />
            <View style={styles.body}>
                <EmptyState
                    icon="compass-outline"
                    title="We couldn’t find that page"
                    subtitle="The link may be old or mistyped. Search for a hotel or head back to the homepage."
                    actionLabel="Go to the homepage"
                    onAction={() => router.replace('/')}
                />
            </View>
        </Screen>
    );
}

const styles = StyleSheet.create({
    body: { flexGrow: 1, justifyContent: 'center', paddingHorizontal: space.card, paddingVertical: space.sectionMajor },
});
